import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation } from 'react-router-dom';
import { Button } from '@naf-simba/elements-buttons';
import { useResolvedNavigationLink } from '../../../hooks/useResolvedNavigationLink';
import { useMembershipStatus } from '../../../hooks/useMembershipStatus';
import { MobileNavCta } from '../../../../../types/globalSettingsType';
import { mapSimbaVariant } from '../../../utils/simba';
import { useHandleNavigationClick } from '../../../utils/Tracking/Navigation/NavigationTracking';
import { AppLink } from '../../AppLink/AppLink';
import * as S from './MobileMenuCta.styles';

interface MobileMenuCtaProps {
  cta?: MobileNavCta | null;
  mobileMenuGroup?: string;
}

type AppLinkButtonProps = React.ComponentProps<typeof Button> & {
  component: typeof AppLink;
  url: string;
  blank?: boolean;
};

const AppLinkButton = Button as React.ComponentType<AppLinkButtonProps>;

export const MobileMenuCta = ({ cta, mobileMenuGroup }: MobileMenuCtaProps) => {
  const { isAuthenticated } = useAuth0();
  const { isMembershipActive } = useMembershipStatus();
  const location = useLocation();
  const { url, blank } = useResolvedNavigationLink({
    data: cta?.link?.referenceComponent,
    type: cta?.link?.type,
    href: cta?.link?.href,
    blank: cta?.blank,
    anchorId: cta?.link?.anchorId,
  });
  const buttonVariant = mapSimbaVariant(cta?.variant);

  const handleOnClick = useHandleNavigationClick({
    event: 'mobileMenuButtonClick',
    menuPage: location.pathname,
    mobileMenuGroup,
    menuItemName: cta?.buttonText ?? '',
    menuItemUrl: url,
  });
  const shouldHideForActiveMember = !!cta?.hideIfMember && isAuthenticated && isMembershipActive;

  if (!cta?.buttonText || !url || shouldHideForActiveMember) return null;

  return (
    <S.Wrapper>
      <AppLinkButton
        component={AppLink}
        url={url}
        blank={blank}
        onClick={handleOnClick}
        size="medium"
        textWrap="nowrap"
        variant={buttonVariant.variant}
        color={buttonVariant.color}
      >
        {cta.buttonText}
      </AppLinkButton>
    </S.Wrapper>
  );
};
